import React, { useState } from 'react'
import { ArrowLeftCircle } from 'react-bootstrap-icons';
import { Link } from 'react-router-dom';

const BackButton = () => {
    const [hovered, setHovered] = useState(false);

  return (
    <Link to="/" style={{ textDecoration: "none" }}>
        <button
          style={{
            position: "absolute",
            top: 26,
            left: 30,
            color: "#fff",
            cursor: "pointer",
          }}
          onMouseEnter={() => setHovered(true)}
          onMouseLeave={() => setHovered(false)}
        >
          <ArrowLeftCircle
            style={{
              marginRight: "8px",
              marginBottom: "4px",
              transition: "transform 0.3s ease-in-out",
              transform: hovered ? "translateX(-10px)" : "translateX(0)",
            }}
            size={20}
          />
          Back to Home
        </button>
      </Link>
  )
}

export default BackButton